/**
 * @desc - Androidのserif対応
 * @link - https://qiita.com/ksk1015/items/9d2028454ee144c64c60
 */

// 読み込むか否かの判定は簡易にUAで判定
(function () {
    if (/android/i.test(navigator.userAgent)) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://fonts.googleapis.com/css?family=Noto+Serif+JP';
        document.head.appendChild(link);
    }
})();